import React, { useContext, useEffect, useRef, useState } from 'react'
import { IconDislike, IconLike } from './icon';
import { saveChatReact } from 'services/mongoDB';
import XBImage from '../../assets/img/XB.png';
import XPMImage from '../../assets/img/XPM.png';
import { evaThemeLighter } from 'services/EVAResponseService';
import SharetoOther from './SharetoOther';
import PinToDashboard from 'components/PinToDashboard/PinToDashboard';
import { MainContext } from 'context/mainContext';
import DashboardTemplateKPIModal from 'eva-component/DashboardTemplateKPIModal';

function Feedback({ messages, index, message, msgReact, userData, theme, integration, stext, version, observation, handleshowEditVisual, 
    templateItemVisual, editedGridCellData, handleNewUpdate, selectedDashboardTemplate, handlePintoDashboardUpdate, integrationImg, handleLoadEVAResponseToTemplate  }) {
    let [isLiked, setIsLike] = useState(null)
    let [isDisliked, setIsDisliked] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPinModalOpen, setIsPinModalOpen] = useState(false);
    const [toggleDashboardKPI, setToggleDashboardKPI] = useState(false);
    const [comment, setComment] = useState('');
    const textareaRef = useRef(null);
    const [shareEvaModal, setShareEvaModal] = useState(false)
    const { isAdminUser } = useContext(MainContext);
    const { business, client, user } = userData

    
    const LikeMessage = () => {
        const data = { _id: messages._id, uuid: messages.uuid, liked: isLiked ? null : true, comment: "" }
        saveChatReact(data)
        setIsLike(!isLiked)
        setIsDisliked(null)
    }
    function DislikeMessage() {
        setIsDisliked(!isDisliked)
        if (!isDisliked)
            setIsModalOpen(true);
    }
    const handleCancel = () => {
        setIsDisliked(null)
        setIsModalOpen(false);
        setComment("")
    };
    const handleSave = () => {
        const data = { _id: messages._id, uuid: messages.uuid, liked: false, comment: comment }
        setIsLike(null)
        setIsModalOpen(false);
        setComment("")
        saveChatReact(data)
    }

    useEffect(() => {
        if (messages.liked !== null && messages.liked !== undefined) {
            setIsLike(messages.liked)
            setIsDisliked(!messages.liked)
        } else {
            setIsLike(messages.liked)
            setIsDisliked(messages.liked)
        }
    }, [messages])

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.focus();
            const textLength = comment.length;
            textareaRef.current.setSelectionRange(textLength, textLength);
        }
    }, [comment]);

    const handleCommentChange = (event) => {
        setComment(event.target.value);
    };

    const ShowDislikeModal = () => {
        return (
            <div className="dislike-modal">
                <div className="dislike-modal-content">
                    <p>I apologize for not meeting your data expectations precisely. We appreciate your valuable feedback and encourage you to share your thoughts to help us improve your conversational experience.</p>
                    <textarea
                        ref={textareaRef}
                        placeholder="The data I received was not reliable."
                        value={comment}
                        onChange={handleCommentChange}
                    />
                    <div className="button-container">
                        <div style={evaThemeLighter(100, theme)} onClick={handleSave}>Send</div>
                        <div style={evaThemeLighter(100, theme)} onClick={handleCancel}>Cancel</div>
                    </div>
                </div>
            </div>
        )
    }
    const fileTypeImages = {
        XB: XBImage,
        XPM: XPMImage,
        default: 'data:image/png;base64,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',
    };
    const handleShowPinModal = (event) => {
        if(event)
        event.preventDefault();
        setIsPinModalOpen(!isPinModalOpen);
    };

    const handleShowEvaModal = () => {
        setShareEvaModal(!shareEvaModal)
    }
    const onHandleshowEditVisual = () => {
        handleshowEditVisual()
    }
    const onToggleDashboardKPI = () => {
        setToggleDashboardKPI(!toggleDashboardKPI)
    }
    return (
        <>
            <div className="like-dislike-container">
                <div className='etaniAiContainer'>
                    <img src={integrationImg || fileTypeImages.default} height={40} alt="Integration Logo" />
                    {/* {!integrationImg && <div className='etaniAIlabel'>Etani AI</div>} */}
                </div>
                <IconLike
                    style={{
                        fill: isLiked && '#005dcd',
                        width: "25px",
                        height: "15px"
                    }}
                    onClick={() => LikeMessage()}
                    className={isLiked ? "Liked" : ""}
                />
                <span className="sr-only">Like</span>
                <IconDislike onClick={() => DislikeMessage()}
                    style={{
                        fill: isDisliked && '#cc0000',
                        width: "25px",
                        height: "15px"
                    }} />
                <span className="sr-only">Dislike</span>
                {typeof handleLoadEVAResponseToTemplate === 'function' ? 
                    <div className='shareResponse' style={evaThemeLighter(80, theme)} onClick={() => handleLoadEVAResponseToTemplate(messages, stext, integration)}>Load to Template</div>
                : 
                <>
                    {stext && <div
                        className='shareResponse'
                        style={evaThemeLighter(80, theme)}
                        onClick={(e) => handleShowPinModal(e)}
                    >
                        Pin
                    </div>}
                </>
                }

                {/* <div className='shareResponse' onClick={handleShowEvaModal} style={evaThemeLighter(80, theme)}>
                    Share
                </div> */}
                <div className='shareResponse' style={evaThemeLighter(80, theme)} onClick={onHandleshowEditVisual} >Edit Visual</div>
                {isAdminUser &&
                    <div className='shareResponse' 
                        onClick={onToggleDashboardKPI} 
                        style={evaThemeLighter(80, theme)}
                    >
                        Save as Template Item
                    </div>
                }

            </div>
            {isModalOpen && (<ShowDislikeModal />)}

            {isPinModalOpen && <PinToDashboard
                theme={theme}
                onShowPinModal={handleShowPinModal}
                userData={userData}
                messageId={messages._id}
                integration={integration}
                stext={stext}
                version={version}
                observation={observation}
                templateItemVisual={templateItemVisual}
                editedGridCellData={editedGridCellData}
                handleNewUpdate={handleNewUpdate}
                selectedDashboardTemplate={selectedDashboardTemplate}
                handlePintoDashboardUpdate={handlePintoDashboardUpdate}
            />}

            {toggleDashboardKPI && <DashboardTemplateKPIModal
                onToggleDashboardKPI={onToggleDashboardKPI}
                messages={messages}
                stext={stext}
                integration={integration}
            />}

            {shareEvaModal && <SharetoOther 
                                handleShowEvaModal={handleShowEvaModal} 
                                theme={theme}
                                messages={messages} />}
        </>
    );
}

export default Feedback